import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { Btn, Field, Modal } from "@/components/rp";

export const ConfirmDelete = ({ open, onClose, title, word, what, onConfirm, testid }) => {
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setV(""); }, [open]);
  const ok = v.trim().toLowerCase() === (word || "").trim().toLowerCase();
  const go = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onConfirm(v.trim()); } catch (err) { toast.error(errMsg(err)); setBusy(false); }
  };
  return (
    <Modal open={open} onOpenChange={(o) => !o && onClose()} title={title} testid={testid}
      description={`Verranno eliminati definitivamente ${what}. L'operazione non si pu\u00f2 annullare.`}>
      <form onSubmit={go} className="space-y-4">
        <Field label={`Per confermare scrivi: ${word}`}><input value={v} onChange={(e) => setV(e.target.value)} className="rp-field" autoFocus data-testid={`${testid}-input`} /></Field>
        <div className="flex justify-end gap-2">
          <Btn type="button" variant="secondary" onClick={onClose}>Annulla</Btn>
          <Btn type="submit" variant="danger" disabled={!ok} loading={busy} data-testid={`${testid}-confirm`}><Trash2 className="h-4 w-4" /> Elimina definitivamente</Btn>
        </div>
      </form>
    </Modal>
  );
};
